import React, { useRef } from 'react';
import { ScrollParallax } from 'react-just-parallax';
import { Link } from 'react-router-dom';
import DefaultButton from './DefaultButton';
import { SlArrowDown } from 'react-icons/sl';

function Static({headerImage, logoTransp, isVideo, srcVideo, videoHeaderRef, title, description, arrow, href, logoPosition, buttonText, scrollDown, aos}) {

  const createMarkup = (htmlContent) => {
    return {__html: htmlContent};
  };

  const nextSectionRef = useRef(null);

  // Function to scroll to the next section
  const scrollToNextSection = () => {
    nextSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <div className='relative z-20 h-lvh mini-screen:h-[500px] overflow-hidden'>
        
        {isVideo ? 
        <video ref={videoHeaderRef} className="absolute top-0 left-0 w-full h-full object-cover" style={{ transform: 'scale(1.2)' }} autoPlay muted playsInline>
          <source src={srcVideo} type="video/mp4" />Your browser does not support the video tag.
        </video> :
        <ScrollParallax enableOnTouchDevice={true} isAbsolutelyPositioned={true} lerpEase="0.05">
          <img src={headerImage} data-aos={aos ? "" : "fade-in"} data-aos-duration={aos ? "" : "2000"} 
          alt='background' className="absolute top-0 left-0 w-full h-full object-cover" />
        </ScrollParallax>
        }

        <div className="absolute top-0 left-0 bg-black bg-opacity-40 w-full h-full flex justify-center items-center">
            {logoTransp !== '' && <img src={logoTransp}
              data-aos="fade-in" data-aos-duration="3000"  
              className={`absolute ${logoPosition} object-contain`}
              alt='logo careisgold'
            />}
            <div className="flex justify-end text-start ps-15 mx-[5%] xl:ml-[50%]"> {/**mx-10 md:mr-[20%] xl:ml-[50%]*/}
              <div className={`lg:w-full lg:mr-[40%]`}>
                <div className="lg:text-5xl text-4xl text-white font-semibold text-balance mini-screen:text-2xl" data-aos="fade-up" data-aos-duration="1000">
                  <h1>{title}</h1>
                </div>
                <div className="text-xl mt-4 mb-10 text-white text-balance mini-screen:text-base" data-aos="fade-up" data-aos-duration="1000">
                  <p>
                    {description}
                    
                  </p>
                </div>
                {arrow && <SlArrowDown
                  data-aos="fade-up"
                  data-aos-delay="600"
                  data-aos-duration="1000"
                  onClick={scrollToNextSection} 
                  className='arrow cursor-pointer block absolute left-1/2 transform -translate-x-1/2 text-slate-50 text-2xl md:text-5xl mini-screen:hidden' />}
                {buttonText && <DefaultButton text={buttonText || 'Scopri di più'} link={href} dark={true} buttonClass='' />}
              </div>
            </div>
        </div>
      </div>
      <div ref={nextSectionRef}></div>
    </>
  );
}

export default Static;
